import { Ionicons } from '@expo/vector-icons';
import { Href, Link, router } from 'expo-router';
import { Linking, Platform, Text, View } from 'react-native';

import { SeoHead, SITE_URL } from '@/components/seo-head';
import { ThemedText } from '@/components/themed-text';
import { Button } from '@/components/ui/button';

/** Caminhos para quem caiu num link quebrado (pessoa ou robô). */
const RECOVERY_LINKS = [
  { label: 'Página inicial', href: '/' },
  { label: 'Guias para quem presta serviço', href: '/guias' },
  { label: 'Central de suporte', href: '/suporte' },
  { label: 'Mapa do site (sitemap.xml)', href: '/sitemap.xml' },
  { label: 'Resumo para IA (llms.txt)', href: '/llms.txt' },
];

/**
 * Rota inexistente dentro do sistema. Perfil público que não existe tem a
 * própria página (ProfileNotFound), com sugestões de perfis reais.
 */
export default function NotFoundScreen() {
  const goBack = () => (router.canGoBack() ? router.back() : router.replace('/'));

  return (
    <View className="flex-1 items-center justify-center bg-neutral-50 px-6">
      <SeoHead title="Página não encontrada · Controlapag" noindex />
      <View className="w-full max-w-sm items-center gap-5">
        <View
          className="h-20 w-20 items-center justify-center rounded-full bg-primary-50 dark:bg-primary"
          style={{ borderCurve: 'continuous' }}
        >
          <Ionicons className="text-primary dark:text-white" name="search-outline" size={36} />
        </View>
        <View className="items-center gap-2">
          <ThemedText role="heading" aria-level={1} className="text-center font-bold text-xl">
            Não encontramos essa página
          </ThemedText>
          <ThemedText className="text-center text-neutral-500">
            O link pode estar errado ou a página foi removida. Volte para onde estava ou
            comece de novo pelo início.
          </ThemedText>
        </View>
        <View className="w-full gap-2">
          <Button variant="default" onPress={() => router.replace('/')}>
            Ir para o início
          </Button>
          <Button variant="ghost" onPress={goBack}>
            Voltar
          </Button>
        </View>
        <View className="w-full items-center gap-2 border-t border-neutral-200 pt-5">
          <ThemedText className="text-center text-sm text-neutral-500">
            Talvez você procure por:
          </ThemedText>
          {RECOVERY_LINKS.map((link) =>
            // Arquivo estático (.xml, .txt): link comum, sem o roteador do app,
            // senão a navegação cai de novo nesta tela.
            /\.(xml|txt)$/.test(link.href) ? (
              <Text
                key={link.href}
                accessibilityRole="link"
                {...(Platform.OS === 'web' ? ({ href: link.href } as object) : {})}
                onPress={
                  Platform.OS === 'web'
                    ? undefined
                    : () => void Linking.openURL(`${SITE_URL}${link.href}`)
                }
                className="font-medium text-sm text-primary underline"
              >
                {link.label}
              </Text>
            ) : (
              <Link
                key={link.href}
                href={link.href as Href}
                className="font-medium text-sm text-primary underline"
              >
                {link.label}
              </Link>
            ),
          )}
        </View>
      </View>
    </View>
  );
}
